import { ChevronDown } from "lucide-react";
import {
  EmptyStateWrapper,
  EmptyStateIconCircle,
  EmptyStateTitle,
  EmptyStateMessage,
  EmptyStateButton,
} from "./styles.purchaseOrderListDesktop";

export default function PurchaseOrderListEmptyState({ pageConfig, nextPage, onOpenPage }) {
  return (
    <EmptyStateWrapper>
      <EmptyStateIconCircle>
        <img src="/logos/tick_logo.svg" alt="" width={60} height={60} />
      </EmptyStateIconCircle>
      <div>
        <EmptyStateTitle>All caught up!</EmptyStateTitle>
        <EmptyStateMessage>{pageConfig.emptyMessage}</EmptyStateMessage>
      </div>
      {nextPage && (
        <EmptyStateButton type="button" onClick={() => onOpenPage(nextPage.key)}>
          Check {nextPage.label}
          <ChevronDown size={12} style={{ transform: "rotate(-90deg)" }} />
        </EmptyStateButton>
      )}
    </EmptyStateWrapper>
  );
}
